import { createSelector } from 'reselect';

export const selectSettings = (state: any) => state.settings;

export const selectCurrent = createSelector([selectSettings], (settings) => settings.value);


